module.exports = __webpack_public_path__ + "media/images/icons/safe-f0e127c94f7d4f935f17611ba202e5d1.svg";